import React from "react";
//#region types
import { AccountingFormTypes } from "models/formTypes";
import { ReportHanlder } from "models/propTypes/accountingPropTypes";
//#endregion
//#region components
import { ExpandAllButton, useFilterContext } from "components/common";
//#endregion

// Shared by resultReport/report.tsx and balanceReport/report.tsx. Both render above the
// FilterContextProvider (DashboardLayout mounts it around `content`, which their toolbars are
// part of), so this button reads/writes the shared pageFilter itself, rather than the parent
// passing state down, to keep expandAllRows persisted (URL + save-as-default) instead of
// local-only React state.
const ExpandAllFilterControl: React.FC<{ reportRef: React.RefObject<ReportHanlder> }> = ({ reportRef }) => {
  const { filter: pageFilter, setFilter: setPageFilter } =
    useFilterContext<AccountingFormTypes.FinancialReportFilter>();
  const expanded = pageFilter?.expandAllRows ?? false;

  const handleToggle = () => {
    if (expanded) {
      reportRef.current?.collapseAll();
    } else {
      reportRef.current?.expandAll();
    }
    setPageFilter({ ...pageFilter, expandAllRows: expanded ? undefined : true });
  };

  return <ExpandAllButton expanded={expanded} onToggle={handleToggle} />;
};

export default ExpandAllFilterControl;
